import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Box, Card, CardContent } from '@mui/material';

import Button from '../../../components/Button/Button';
import SvgIcon from '../../../components/Icons';

const AddOffer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() => navigate('/offers/create')}
      sx={{
        minHeight: '390px',
        maxHeight: '390px',
        maxWidth: 345,
        height: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        border: '1px dashed #eee',
        background: 'transparent',
        boxShadow: '0px 0px 20px 0px #0000000F',
        fontFamily: 'Poppins',
        cursor: 'pointer',
        borderRadius: '12px',
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': {
          boxShadow: '0px 4px 24px 0px #00000014',
        },
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pb: '72px',
        }}
      >
        <Box display='flex'>
          <SvgIcon name='NewOffer' inheritViewBox sx={{ fontSize: 100 }} />
        </Box>
      </CardContent>
      <Box sx={{ position: 'absolute', left: 14, right: 14, bottom: 13 }}>
        <Button
          component={Link}
          to='/offers/create'
          variant='contained'
          size='large'
          fullWidth
          sx={{ borderRadius: '8px' }}
        >
          Create new offer
        </Button>
      </Box>
    </Card>
  );
};

export default AddOffer;
